// ProcessSection.tsx
import React, { useEffect } from 'react'
import { motion, useAnimation } from 'framer-motion'
import Image from 'next/image'
import { useInView } from 'react-intersection-observer'

interface ProcessStep {
  imageSrc: string
  title: string
}

interface ProcessSectionProps {
  steps: ProcessStep[]
}

const ProcessSection: React.FC<ProcessSectionProps> = ({ steps }) => {
  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start('visible')
    }
  }, [controls, inView])

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  }

  const stepVariants = {
    hidden: { opacity: 0, x: -100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 10,
      },
    },
  }

  return (
    //this below code is useful for unlimited animation
      <div ref={ref} className="row box justify-content-center">
        <motion.div
        key={Math.random()}
        className="row mt-4 box justify-content-center"
        variants={containerVariants}
        initial="hidden"
        animate={controls}
        >
          {steps.map((step,index)=>(
            <motion.div
            key={index}
            className="col-md-4 col-xxl-2 col-sm-4 col-6 mil-mb-30"
            style={{ textAlign: 'center' }}
            variants={stepVariants}
            >
              <Image
               src={`${step.imageSrc}`}
                         height={100}
                         width={100}
                         className='mb-3'
                         alt={step.title}
                       />
                        <p className="mil-mb-30 mil-h5" style={{fontSize:"16px"}}>
                                {step.title}
                        </p>
                       {/* <h5 className="mil-mb-30 mil-h5" style={{fontSize:"16px"}}>{step.title}</h5> */}
            </motion.div>
          ))}
        </motion.div>
        </div>
  )
}

export default ProcessSection
